import React from "react"
import PropTypes from "prop-types"

class TopicSelector extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false
    }
    this.selectorStyle = this.selectorStyle.bind(this)
  }

  selectorStyle(n) {
    if(this.props.selectedTab === n) {
      return{
        textAlign: 'center',
        color: '#fff',
        backgroundColor: '#03A9F4',
        padding: 10,
        borderRadius: 30,
        width: '33%'
      }
    }
    return{
      textAlign: 'center',
      color: '#03A9F4',
      padding: 10,
      width: '33%'
    }
  }

  render() {
    return(
      <div style={{
        margin: 'auto',
        backgroundColor: 'white',
        maxWidth: 350,
        flexDirection: 'row',
        justifyContent: 'space-between',
        display: 'flex',
        borderRadius: 30,
        marginTop: 12,
        marginBottom: 12,
        cursor: 'pointer',
      }}>
        <h5 style={this.selectorStyle(1)} onClick={() => this.props.onSelectTab(1)}>Saved</h5>
        <h5 style={this.selectorStyle(3)} onClick={() => this.props.onSelectTab(3)}>Search</h5>
      </div>
    )
  }

}

export default TopicSelector;
//        <h5 style={this.selectorStyle(2)} onClick={() => this.props.onSelectTab(2)}>My Topics</h5>
